import React, { useState, useEffect, useContext } from 'react';
import {
    Grid,
    Button,
    Typography,
    TextField
} from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { language } from 'config';
import { makeStyles } from '@material-ui/core/styles';
import { FirebaseContext } from 'common';

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    container: {
        zIndex: "12",
        color: "#FFFFFF",
        alignContent: 'center'
    },
    title: {
        color: "#000",
    },
    gridcontainer: {
        alignContent: 'center'
    },
    items: {
        margin: 0,
        width: '100%'
    },
    input: {
        fontSize: 18,
        color: "#000"
    },
    inputdimmed: {
        fontSize: 18,
        color: "#737373"
    },
    carphoto: {
        height: '18px',
        marginRight: '10px'
    },
    buttonStyle: {
        margin: 0,
        width: '100%',
        height: '100%'
    }
}));

export default function SuperSettings(props) {
    const { api } = useContext(FirebaseContext);
    const {
        removeAllBooking
    } = api;
    const dispatch = useDispatch();
    const classes = useStyles();
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
    const [lists, setLists] = useState(["bookings"]);


    const removeAllBookings = () => {
        window.confirm("Are you sure?") && dispatch(removeAllBooking());
    }

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: '' })
    };

    return (
        <div className={classes.container}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
                <Grid container spacing={2} >
                    <Grid item xs={12}>
                        <Typography component="h1" variant="h5" className={classes.title}>
                            Super Settings
                        </Typography>
                    </Grid>
                    {/* <Grid item xs={12}>
                        {lists ?
                            <UsersCombo
                                className={classes.items}
                                placeholder={language.select_user}
                                users={lists}
                                value={userCombo}
                                onChange={(event, newValue) => {
                                    setUserCombo(newValue);
                                }}
                            />
                            : null}
                    </Grid> */}
                    <Grid item xs={12} sm={6} >
                        <Button
                            size="large"
                            onClick={removeAllBookings}
                            variant="contained"
                            color="primary"
                            className={classes.buttonStyle}
                        >
                            Remove all bookings history
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
        </div>
    );
}